import React from 'react'

import { OauthStatusInterface } from '@/interfaces/oauth'
import {
  disconnectGoogleAccount,
  disconnectInstagram,
  disconnectinstagramBasic,
  disconnectTikTokAccount,
  getGoogleUrl,
  getinstagramBasicUrl,
  getInstagramUrl,
  getOauthGeneralStatus,
  getTiktokUrl,
} from '@/services/oAuth'
import { UserContext } from 'context'
import { OauthRequestSocialType } from 'containers/oAuth/types/oAuth'

export const useSocialConnection = () => {
  const { user } = React.useContext(UserContext)
  const [status, setStatus] = React.useState<OauthStatusInterface>(null)
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    const getStatus = async () => {
      setLoading(true)
      const res = await getOauthGeneralStatus(user.id)
      if (res && !res.error) {
        setStatus(res)
      }
      setLoading(false)
    }
    getStatus()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const openSocialLinkAuthentication = async (
    social: OauthRequestSocialType
  ) => {
    const service =
      social === OauthRequestSocialType.YOUTUBE
        ? getGoogleUrl
        : social === OauthRequestSocialType.INSTAGRAM
        ? getInstagramUrl
        : social === OauthRequestSocialType.INSTAGRAM_BASIC
        ? getinstagramBasicUrl
        : getTiktokUrl

    setLoading(true)

    const res = await service()

    if (res.url) {
      window.location.href = res.url
    }

    setLoading(false)
  }

  const getStatus = async () => {
    setLoading(true)
    const res = await getOauthGeneralStatus(user.id)

    if (res && !res.error) {
      setStatus(res)
    }
    setLoading(false)
  }

  const disConnectSocial = async (social: OauthRequestSocialType) => {
    setLoading(true)
    const service =
      social === 'youtube'
        ? disconnectGoogleAccount
        : social === 'instagram'
        ? disconnectInstagram
        : social === 'instagram-basic'
        ? disconnectinstagramBasic
        : disconnectTikTokAccount
    await service()
    await getStatus()
    setLoading(false)
  }

  return { openSocialLinkAuthentication, status, loading, disConnectSocial }
}
